import { render, staticRenderFns } from "./Fuli.vue?vue&type=template&id=3f006cce&scoped=true"
import script from "./Fuli.vue?vue&type=script&lang=js"
export * from "./Fuli.vue?vue&type=script&lang=js"
import style0 from "./Fuli.vue?vue&type=style&index=0&id=3f006cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f006cce",
  null
  
)

export default component.exports